import React, { useEffect, useState } from "react";
import Modal from "../../../../elements/Modal";
import useFetch from "../../../../../hooks/useFetch";
import {
  applicationDetails,
  resumeStepDetails,
  stepList,
} from "../../../../../services/applicationFormService";
import StudentInformationFormFront from "./StudentInformationFormFront";
import GurdianInformationFormFront from "./GuardianInformationFormFront";
import SchoolInfoFormFront from "./SchoolInfoFormFront";
import SchoolPaymentInfoFront from "./SchoolPaymentInfoFront";
import WarningsFront from "./WarningsFront";
import SupportingDocFormFront from "./SupportingDocFormFront";
import CertificationFormFront from "./CertificationFormFront";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const ApplicationModalFront = ({ open, close = () => {}, details }) => {
  const [currentStepSlug, setCurrentStepSlug] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState({
    type: "",
    submitted: false,
  });

  const user = useSelector((state) => state?.profile?.data);

  const { data: stepsList } = useFetch({
    dependencies: ["stepsList"],
    fetchFunction: async () => {
      const res = await stepList({ formId: details?.applicationFormId });
      return res?.data;
    },
  });

  const scholarshipId = details?.scholarshipId
    ? details?.scholarshipId
    : details?._id;

  const { data: resumeStep, error } = useFetch({
    dependencies: [details?.applicationFormId, details?._id],
    fetchFunction: async () => {
      const res = await resumeStepDetails({
        formId: details?.applicationFormId,
        userId: user?._id,
        scholarshipId: scholarshipId,
        ...(details?.statusDetails?.title === "Draft" && {
          status: details?.statusDetails?.title,
        }),
      });

      if (res?.groupCode) {
        return res.groupCode;
      } else {
        toast?.error(
          res?.message || "Something went wrong while fetching groupCode"
        );
        close();
      }
    },
  });

  useEffect(() => {
    if (resumeStep) {
      setCurrentStepSlug(resumeStep);
    } else {
      setCurrentStepSlug(null);
    }
  }, [resumeStep]);

  const { data, isLoading, refetch } = useFetch({
    enabled: !!details?.applicationFormId && !!currentStepSlug,
    dependencies: [details?.applicationFormId, currentStepSlug],
    fetchFunction: async () => {
      if (!details?.applicationFormId || !currentStepSlug) return null;

      // if (stepDataCache[currentStepSlug]) {
      //   return stepDataCache[currentStepSlug];
      // }

      setLoaded(true);

      const res = await applicationDetails({
        formId: details.applicationFormId,
        groupCode: currentStepSlug,
        userId: user?._id,
        scholarshipId: scholarshipId,
      });

      const newData = res?.groupCodeWiseData;

      // setStepDataCache((prev) => ({
      //   ...prev,
      //   [currentStepSlug]: newData,
      // }));

      return newData;
    },
    onSuccess: () => setLoaded(false),
    onError: () => setLoaded(false),
  });

  const continueHandler = () => {
    const index = stepsList.findIndex((step) => step.slug === currentStepSlug);
    if (index < stepsList.length - 1) {
      setCurrentStepSlug(stepsList[index + 1].slug);
    }
  };
  const backHandler = () => {
    const index = stepsList.findIndex((step) => step.slug === currentStepSlug);
    if (index > 0) {
      setCurrentStepSlug(stepsList[index - 1].slug);
    }
  };

  const commonProps = {
    data,
    details,
    scholarshipId,
    setLoaded,
    loaded,
    close,
    continueHandler,
    backHandler,
  };

  const stepComponents = {
    Application_Form: <WarningsFront {...commonProps} />,
    Student_Personal_Information: (
      <StudentInformationFormFront {...commonProps} />
    ),
    Parent_Guardian_Information: (
      <GurdianInformationFormFront {...commonProps} />
    ),
    School_Information: <SchoolInfoFormFront {...commonProps} />,
    School_Payment_Information: <SchoolPaymentInfoFront {...commonProps} />,
    Supporting_Documents: <SupportingDocFormFront {...commonProps} />,
    Certification_and_Authorization: (
      <CertificationFormFront
        {...commonProps}
        isSubmitted={isSubmitted}
        setIsSubmitted={setIsSubmitted}
      />
    ),
  };

  const title =
    stepsList?.find((step) => step.slug === currentStepSlug)?.title || "";

  const ModalClose = () => {
    close();
    setCurrentStepSlug(null);
    setIsSubmitted({ type: "", submitted: false });
  };
  return (
    <Modal
      isOpen={open}
      setIsOpen={ModalClose}
      size="xl4"
      title={
        isSubmitted?.submitted
          ? isSubmitted?.type === "save"
            ? "💾 Progress Saved"
            : " 🎉 Application Submitted Successfully!"
          : title
      }
      bodyClasses={"py-14 px-10 md:!py-10 md:!px-14"}
    >
      {isLoading || !currentStepSlug ? (
        <div>Loading...</div>
      ) : (
        stepComponents[currentStepSlug] || <div>Step Not Found</div>
      )}
    </Modal>
  );
};

export default ApplicationModalFront;
